
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInputMouse1 as ObiInputMouse1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-input-mouse-1.js';
 
 
 

 
 export const ObiInputMouse1 = createComponent({
   react: React,
   tagName: 'obi-input-mouse-1',
   elementClass: ObiInputMouse1Element,
   events: {
     
   }
  });
 
 